import React from "react";

const AsesoresHero = () => {
  return (
    <div className="asesores-hero-wrapper">
      <div className="asesores-hero-text-col">
        <h1 className="beba-font asesores-hero-title">
          Conoce a los asesores{" "}
          <span className="text-primary">que te ayudan a transportar tu</span>{" "}
          <span className="text-secondary">vehículo sin que manejes</span>
        </h1>
        <p className="mt-3 asesores-hero-subtitle">
          Asesores verificados, atención directa por WhatsApp.
        </p>
      </div>
      <div className="asesores-hero-img-col">
        <img
          src="/images/advisors-banner.jpg"
          alt="Asesores Puerto Rico Car Transfer"
          className="asesores-hero-image"
        />
      </div>
    </div>
  );
};

export default AsesoresHero;
